package org.zest.insan_360_website.pages.user.report_layout

import androidx.compose.runtime.Composable

@Composable
fun AdminLayout() {
    ReportHandling()
}